import { PostModel, PostType, SubscriptionType } from '$store/models';
import { useCurrentUserInfo, useUserInfo } from '$hooks/useUserInfo';
import { useSelector } from 'react-redux';
import { mainSelector } from '$store/main';

export const useDecryptKey = (post?: PostModel) => {
  const user = useUserInfo(post?.ownerId || 0);
  const { decryptKeys } = useSelector(mainSelector);
  // const currentUser = useCurrentUserInfo();

  if (!post) {
    return '';
  }

  if (post.ownerId < 0) {
    if (post.type === PostType.SUBSCRIPTION) {
      return decryptKeys[-SubscriptionType.Media];
    }
  }

  let subscriptionType = -2;
  if (post.type === PostType.SUBSCRIPTION) {
    if (post.sponsored) {
      subscriptionType = user.id;
    } else if (user.verified === 2) {
      subscriptionType = -1;
    }
  } else if (post.type === PostType.PRIVATE_SUBSCRIPTION) {
    subscriptionType = user.id;
    // } else if (post.type === PostType.FREE) {
    //   subscriptionType = -SubscriptionType.Basic;
  }
  return decryptKeys[subscriptionType];
};
